var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240-400h122l241-241-119-125-244 244zm280-243-37-37zM300-460v-38l101-101 20 18 18 20-101 101zm121-121 18 20-38-38zm26 181h273v-80H527zM80-80v-800h800v640H240zm126-240h594v-480H160v525zm-46 0v-480z"
  })));
};
export default SvgFeedback;